import salaryService from 'ApiService/Accountant/salaryService';
import { AuthContext } from 'contexts/AuthContext';
import Nodatafound from 'pages/Common/Nodatafound';
import { useContext, useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { ThreeDots } from 'react-loader-spinner';
import { useNavigate } from 'react-router-dom';
import UpdateSalaryModal from '../Models/UpdateSalaryModal';

const Index = () => {
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [employeeType, setEmployeeType] = useState('Admin');
  const [isUpdateModalOpen, setIsUpdateModalOpen] = useState(false);
  const [employeeToUpdate, setEmployeeToUpdate] = useState(null);
  const { state } = useContext(AuthContext);

  // Handle navigation based on role

  const handleOpenUpdateModal = (employee) => {
    setEmployeeToUpdate(employee);
    setIsUpdateModalOpen(true);
  };

  const handleCloseUpdateModal = () => {
    setIsUpdateModalOpen(false);
    setEmployeeToUpdate(null);
  };

  const handleSalaryUpdated = () => {
    fetchUserData(); // Refresh the data
  };

  const navigate = useNavigate();

  function reset() {
    setFilteredData(data);
    setSearchTerm('');
    setEmployeeType('Admin');
    fetchUserData('Admin');
  }

  const fetchUserData = async () => {
    setLoading(true);
    setData([]);
    setFilteredData([]);

    try {
      const selectedBranch = state?.selectedBranch || '';
      const response = await salaryService.getEmployee(
        employeeType,
        selectedBranch
      );

      if (response.data.success) {
        const employees = response.data.employees || [];
        setData(employees);
        setFilteredData(employees);

        if (!employees || employees.length === 0) {
          toast.error(`No data found for ${employeeType} users in this branch`);
        }
      } else {
        toast.error('Failed to fetch employee data');
      }
    } catch (error) {
      toast.error(
        error.response?.data?.message || 'An error occurred while fetching data'
      );
      setData([]);
      setFilteredData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUserData();
  }, [employeeType, state?.selectedBranch]);

  useEffect(() => {
    let result = data;
    if (searchTerm) {
      result = data.filter(
        (user) =>
          user.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
          user.email.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }
    setFilteredData(result);
  }, [data, searchTerm]);

  const handleEmployeeTypeChange = (e) => {
    setEmployeeType(e.target.value);
  };

  // if (state?.user?.role === 'account') {
  //   return null;
  // }

  const handleNavigation = () => {
    if (state?.user?.role === 'superadmin') {
      navigate('/superadmin/create/salary');
    } else if (state?.user?.role === 'admin') {
      navigate('/admin/create/salary');
    }
  };

  return (
    <div className="mt-4 h-full w-full md:mt-4">
      {loading ? (
        <div className="flex h-40 items-center justify-center">
          <ThreeDots color="#5431ed" className="mt-100" />
        </div>
      ) : (
        <>
          <div className="mt-10 flex flex-col items-center gap-4 sm:flex-row">
            <div className="w-full sm:w-[300px] ">
              <div className="w-full rounded-xl border border-gray-200 py-3 pl-2.5 pr-3 text-sm font-normal text-gray-600 outline-none dark:!border-white/10 dark:!bg-navy-800 dark:text-white sm:w-full md:w-full">
                <select
                  className="text-lightFourth w-full rounded-xl pr-4 text-sm outline-none dark:!bg-navy-800 dark:text-white"
                  value={employeeType}
                  onChange={handleEmployeeTypeChange}
                >
                  <option value="Admin">Admin</option>
                  <option value="Teacher">Teacher</option>
                  <option value="Account">Accountant</option>
                  <option value="Placement">HRs</option>
                </select>
              </div>
            </div>

            <div className="w-full rounded-xl border border-gray-200 bg-lightPrimary py-2.5 pl-2.5 pr-3 text-sm font-normal text-gray-600 outline-none dark:!border-white/10 dark:!bg-navy-800 dark:text-white sm:w-full md:w-full">
              <input
                type="text"
                placeholder="Search Employee...."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="block w-full rounded-full bg-lightPrimary text-base text-navy-700 outline-none dark:!bg-navy-800 dark:text-white"
              />
            </div>
          </div>
          <div className="mt-[14px] h-full w-full overflow-x-scroll 2xl:overflow-x-hidden">
            <table className="w-full font-dm">
              <thead className="w-full">
                <tr className="items-center border-b border-gray-200 dark:border-white/10">
                  <th className="px-[27px] pb-[12px] pt-[32px] text-start text-xs tracking-wide text-gray-600">
                    <div className="text-xs font-bold">Sr No.</div>
                  </th>
                  <th className="px-[27px] pb-[12px] pt-[32px] text-start text-xs tracking-wide text-gray-600">
                    <div className="text-xs font-bold">USER NAME</div>
                  </th>
                  <th className="px-[27px] pb-[12px] pt-[32px] text-start text-xs tracking-wide text-gray-600">
                    <div className="text-xs font-bold">EMAIL</div>
                  </th>
                  <th className="px-[27px] pb-[12px] pt-[32px] text-start text-xs tracking-wide text-gray-600">
                    <div className="text-xs font-bold">SALARY</div>
                  </th>

                  <th className="px-[27px] pb-[12px] pt-[32px] text-start text-xs tracking-wide text-gray-600">
                    <div className="text-xs font-bold">ACTIONS</div>
                  </th>
                </tr>
              </thead>
              <tbody>
                {filteredData.length > 0 ? (
                  filteredData.map((row, index) => (
                    <tr
                      className="items-center border-b border-gray-200 dark:border-white/10"
                      key={index}
                    >
                      <td className="mt-[20px] px-[27px] py-[16px]">
                        <div className="w-full text-start font-medium text-navy-700 dark:text-white">
                          {index + 1}
                        </div>
                      </td>
                      <td className="mt-[20px] px-[27px] py-[16px]">
                        <div className="w-full text-start font-medium text-navy-700 dark:text-white">
                          {row.name}
                        </div>
                      </td>
                      <td className="mt-[20px] px-4 px-[27px] py-[16px]">
                        <div className="w-full text-start font-medium text-navy-700 dark:text-white">
                          {row.email}
                        </div>
                      </td>
                      <td className="mt-[20px] px-4 px-[27px] py-[16px]">
                        <div className="w-full text-start font-medium text-navy-700 dark:text-white">
                          {row.salary || 'n/a'}
                        </div>
                      </td>

                      <td>
                        {row.salary === null ? (
                          <button
                            onClick={handleNavigation}
                            className="rounded-lg bg-brand-500 px-4 py-2 text-white transition duration-200 hover:bg-brand-800 active:bg-brand-700 dark:bg-brand-400 dark:hover:bg-brand-300 dark:active:opacity-90"
                          >
                            Create Salary
                          </button>
                        ) : (
                          <button
                            onClick={() => handleOpenUpdateModal(row)}
                            className="rounded-lg bg-brand-500 px-4 py-2 text-white transition duration-200 hover:bg-brand-800 active:bg-brand-700 dark:bg-brand-400 dark:hover:bg-brand-300 dark:active:opacity-90"
                          >
                            Update Salary
                          </button>
                        )}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="7" className="py-4 text-center text-gray-500">
                      <Nodatafound title={`No ${employeeType} data found`} />
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {isUpdateModalOpen && (
            <UpdateSalaryModal
              employee={employeeToUpdate}
              onClose={handleCloseUpdateModal}
              onSalaryUpdated={handleSalaryUpdated}
            />
          )}
        </>
      )}
    </div>
  );
};

export default Index;
